import { combineReducers } from "redux";
import { reducer as obterTermoAceiteAtivo } from "./actions/obterTermoAceiteAtivo";
import { reducer as aceitarTermoAceite } from "./actions/aceitarTermoAceite";
export default combineReducers({
  obterTermoAceiteAtivo,
  aceitarTermoAceite
});
